import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "eudr_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  return String(d);
}

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const fmtNum = (n, d = 0) =>
  n == null || isNaN(n) ? "—" : Number(n).toLocaleString("en-GB", { maximumFractionDigits: d, minimumFractionDigits: 0 });

export const fmtMoney = (n, cur = "GBP", compact = false) =>
  n == null || isNaN(n)
    ? "—"
    : Number(n).toLocaleString("en-GB", {
        style: "currency",
        currency: cur || "GBP",
        maximumFractionDigits: compact ? 1 : 0,
        notation: compact ? "compact" : "standard",
      });

export const fmtDate = (s, time = false) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return time
    ? d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const timeAgo = (s) => {
  if (!s) return "never";
  const m = (Date.now() - new Date(s).getTime()) / 60000;
  if (m < 1) return "just now";
  if (m < 60) return `${Math.round(m)} min ago`;
  if (m < 60 * 48) return `${Math.round(m / 60)} h ago`;
  return `${Math.round(m / 1440)} days ago`;
};
